// extracted by mini-css-extract-plugin
module.exports = {"group":"Select_group__39elU","mobile":"Select_mobile__1W45G"};